"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemTitle = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../../theme/colors");
var text_eyebrow_1 = require("../../text-eyebrow");
function MenuItemTitle(props) {
    var children = props.children;
    return (react_1.default.createElement(StyledTitle, null,
        react_1.default.createElement(text_eyebrow_1.TextEyebrow, { color: colors_1.colors.steel[300] }, children)));
}
exports.MenuItemTitle = MenuItemTitle;
var StyledTitle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  margin-top: 16px;\n  padding: 0 24px;\n  margin-bottom: 8px;\n"], ["\n  margin-top: 16px;\n  padding: 0 24px;\n  margin-bottom: 8px;\n"])));
var templateObject_1;
//# sourceMappingURL=title.js.map